import { Button, Container, Title } from '@/components'
import { Swiper, SwiperSlide } from 'swiper/react'
import Image from 'next/image'
import { useState } from 'react'

import useTypesTrainingNew from './hooks'
import useClickWithScroll from '@/utils/browser/useClickWithScroll'

import styles from './styles.module.scss'

const TypesTrainingNew = ({ customClass, isPink = false }) => {
  const { onClickItem } = useClickWithScroll()
  const { TRAININGS, settings, isMobile } = useTypesTrainingNew()
  const [flippedCardIndex, setFlippedCardIndex] = useState(null)

  const handleFlip = (index) => {
    setFlippedCardIndex((prev) => (prev === index ? null : index))
  }

  return (
    <section
      className={`fgt-section ${styles.training} ${customClass}`}
      id="trainingNew"
    >
      <Container classname={styles.container}>
        <Title
          Tag="h2"
          alignText="center"
          variant={isPink ? 'pink' : ''}
          colorText={'light'}
        >
          TREINOS PARA <span>TODOS OS NÍVEIS</span> QUE COMBINAM COM VOCÊ
        </Title>
        <p className={`fgt-subtitle ${styles.subtitle}`}>
          Chega de dúvidas ou exercícios perdidos. Com nossos programas de
          treino, você terá o passo a passo exato para conquistar o corpo que
          sempre buscou. Confira alguns dos nossos treinos mais populares:
        </p>

        <Swiper {...settings} className={`fgt-swiper ${styles.carrossel}`}>
          {TRAININGS.map((item, index) => (
            <SwiperSlide key={index}>
              <div
                className={`${styles.item} ${
                  flippedCardIndex === index ? styles.flipped : ''
                }`}
                onClick={() => handleFlip(index)}
              >
                <div className={styles.inner}>
                  <div className={styles.front}>
                    <Image
                      className={styles.image}
                      src={item.imageUrl}
                      alt={item.alt}
                      width={324}
                      height={404}
                    />
                  </div>
                  <div className={styles.back}>
                    <div className={styles.infos}>
                      <Image
                        className={styles.image}
                        src={item.imageUrl}
                        alt={item.alt}
                        width={324}
                        height={404}
                      />
                      <div className={styles.content}>
                        <div className={styles.description}>
                          {item.description}
                        </div>
                        {!isMobile && (
                          <Button
                            variant="primary"
                            id={`btn-section-training-${item.id}`}
                            className={'fgt-section__action--button'}
                            onClick={() => onClickItem('comparePlans', 0)}
                          >
                            QUERO COMEÇAR AGORA
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </section>
  )
}

export default TypesTrainingNew
